import { init, data, tag } from '@blotoutio/edgetag-sdk-js'

export default ({ app, $config }, inject) => {
  init({
    edgeURL: $config.blotoutUrl,
    disableConsentCheck: true
  })
  inject('blotout', {
    sendEvent: (name, opts) => {
      !opts ? tag(name) : tag(name, opts)
    },
    sendUserData: (opts = {}) => {
      data(opts)
    }
  })
}
